import {TextAnimations} from "./text-animation";
import {ImageReveal} from "./image-reveal";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);
window.addEventListener('load', () => {

    const sectionContactBlockSocial = document.querySelector('.mksun-block-social--contact');

    if (sectionContactBlockSocial) {
        const TextAnimationBlockSocial = new TextAnimations([
            {
                selector: '.mksun-block-social--contact h1',
                type: 'words',
                position: '>'
            }
        ], sectionContactBlockSocial, {});

        TextAnimationBlockSocial.init();

        TextAnimationBlockSocial.timeLine.from(
            '.mksun-block-social--contact__ctn',
            {
                opacity: 0,
                duration: .25,
                ease: 'power1.out',
                stagger: 0.1
            }
        )

        TextAnimationBlockSocial.animate();

        TextAnimationBlockSocial.timeLine.from(
            '.mksun-block-social--contact__ctn__grid__card',
            {
                y: 24,
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
                stagger: 0.1
            },
            '>'
        )
    }

    const sectionContactBlockMap = document.querySelector('.mksun-block-map--contact');
    if (sectionContactBlockMap) {
        const TextAnimationBlockMap = new TextAnimations([
            {
                selector: '.mksun-block-map--contact__ctn__text__content p',
                type: 'words',
                position: '>'
            },
            {
                selector: '.mksun-block-map--contact__ctn__text__content h2',
                type: 'words',
                position: '>'
            }
        ], sectionContactBlockMap, {}, {start: "top 50%"});

        TextAnimationBlockMap.init();

        const ImageRevealBlockMap = new ImageReveal([
            {
                selector: '.mksun-block-map--contact__ctn__map',
                position: '>'
            }
        ], TextAnimationBlockMap.timeLine);

        ImageRevealBlockMap.init();
        ImageRevealBlockMap.animate();

        TextAnimationBlockMap.animate();

        TextAnimationBlockMap.timeLine.from(
            '.mksun-block-map--contact__ctn__text__addresses__item',
            {
                opacity: 0,
                y: 24,
                duration: .5,
                ease: 'power1.out',
                stagger: 0.1
            }
        )
    }

    const sectionContactBlockExpert = document.querySelector('.mksun-block-expert--contact');

    if (sectionContactBlockExpert) {
        const TextAnimationBlockExpert = new TextAnimations([
            {
                selector: '.mksun-block-expert--contact p.text-primary',
                type: 'words',
                position: '='
            }, {
                selector: '.mksun-block-expert--contact h2',
                type: 'words',
                position: '>'
            }, {
                selector: '.mksun-block-expert--contact__ctn__text__content > div',
                type: 'lines',
                position: '>'
            }
        ], sectionContactBlockExpert, {}, {start: "top 50%"});

        TextAnimationBlockExpert.init();

        const imageRevealBlockExpert = new ImageReveal([
            {
                selector: '.mksun-block-expert--contact__ctn__img',
                position: '<'
            }
        ], TextAnimationBlockExpert.timeLine);
        imageRevealBlockExpert.init();

        TextAnimationBlockExpert.timeLine.from(
            '.mksun-block-expert--contact__ctn',
            {
                opacity: 0,
                duration: .25,
                ease: 'power1.out',
                stagger: 0.1
            }
        )

        imageRevealBlockExpert.animate();

        TextAnimationBlockExpert.animate();

        TextAnimationBlockExpert.timeLine.from(
            '.mksun-block-expert--contact .btn',
            {
                y: 24,
                opacity: 0,
                duration: 0.25,
                ease: 'power1.out',
                stagger: 0.1
            },
            '>'
        )
    }

    const sectionContactBlockPress = document.querySelector('.mksun-block-press--contact');
    if (sectionContactBlockPress) {
        const TextAnimationBlockPress = new TextAnimations([
            {
                selector: '.mksun-block-press--contact h2',
                type: 'words',
                position: '>'
            }
        ], sectionContactBlockPress, {}, {start: "top 50%"});

        TextAnimationBlockPress.init();
        TextAnimationBlockPress.animate();

        TextAnimationBlockPress.timeLine.from(
            '.mksun-block-press--contact__ctn__item',
            {
                y: 24,
                opacity: 0,
                duration: 0.5,
                ease: 'power1.out',
                stagger: 0.1
            },
            '>'
        )
    }

});